module.exports = __webpack_public_path__ + "static/media/cg.2c5847e2.jpg";